const styles = {
  title: {
    marginBottom: {
      xs: '24px',
      xl: '50px',
    },
    color: 'kit.text.h',
  },
  titleDifferent: {
    marginBottom: {
      xs: '34px',
      xl: '45px',
    },
    color: {
      xs: 'kit.text.black',
      xl: 'kit.text.h',
    },
  },
  link: {
    textDecoration: 'none',
  },
  button: (theme) => ({
    marginTop: '52px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0',
    },
  }),
};

export default styles;
